var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdsiLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.501,
    height: 48.997,
    viewBox: "0 0 173.501 48.997",
    id: "",
    className: "style-svg replaced-svg svg-replaced-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-675.544 -393.984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821.212,404.085v-8.37h-9.068v8.37Z",
    transform: "translate(27.834 0.353)",
    fill: "#25bdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.869,442.979V406.394h.219l12.507,36.587h10.2l12.4-36.587h.317v36.586h10.333v-49H716.351L703.7,431.771l-12.66-37.787H675.544v48.993Zm163.171-.016v-35h-9.062v35.013Zm-17.253-48.98h-31.3a17.715,17.715,0,0,0-4.437.633,13.033,13.033,0,0,0-4.526,2.239,12.751,12.751,0,0,0-3.593,4.334,14.966,14.966,0,0,0-1.445,7.024,15.172,15.172,0,0,0,1.445,7.056,12.717,12.717,0,0,0,3.593,4.372,12.976,12.976,0,0,0,4.566,2.239,17.664,17.664,0,0,0,4.437.633h15.118a6.5,6.5,0,0,1,4.5,1.695A5.634,5.634,0,0,1,822,428.556a5.834,5.834,0,0,1-.5,2.433,5.913,5.913,0,0,1-1.354,1.89,6.67,6.67,0,0,1-4.542,1.76H788.52v8.337h31.866a16.86,16.86,0,0,0,4.372-.657,13.176,13.176,0,0,0,4.566-2.3,13.036,13.036,0,0,0,3.561-4.4,15.188,15.188,0,0,0,1.452-7.056,15.359,15.359,0,0,0-1.452-7.081,13,13,0,0,0-3.593-4.444,13.2,13.2,0,0,0-4.518-2.3,16.607,16.607,0,0,0-4.372-.664h-15.2a8.879,8.879,0,0,1-2.433-.317,5.655,5.655,0,0,1-1.971-1.014,4.765,4.765,0,0,1-1.387-1.792,6.644,6.644,0,0,1-.5-2.741,5.208,5.208,0,0,1,1.89-4.388,6.985,6.985,0,0,1,4.4-1.452h26.578Zm-94.894,48.993h25.881q9.888,0,14.891-6.293t5.015-18.2q0-11.917-5.012-18.2t-14.893-6.3H736.884v48.993Zm10.316-40.617h12.166q6.359,0,9.133,4.128t2.735,12q0,7.869-2.769,12t-9.116,4.16H747.2v-32.28Z",
    transform: "translate(0)",
    fill: "#000000d9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdsiLogoDark);
export default __webpack_public_path__ + "static/media/mdsi-logo-dark.85a15912860559019537f7aa22594aa3.svg";
export { ForwardRef as ReactComponent };